import http from "@/http/aisea/axios";
const resource = "/enterprises/owner/manning/crews";

export default {
  fetchCrews(params) {
    return http.get(`${resource}`, {
      params: params,
    });
  },
};
